const AngleDown = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M8.0005 9.83319C7.8725 9.83319 7.74448 9.78454 7.64715 9.68654L4.98048 7.01987C4.78515 6.82454 4.78515 6.50785 4.98048 6.31252C5.17582 6.11718 5.49251 6.11718 5.68784 6.31252L8.00115 8.62583L10.3145 6.31252C10.5098 6.11718 10.8265 6.11718 11.0218 6.31252C11.2172 6.50785 11.2172 6.82454 11.0218 7.01987L8.35516 9.68654C8.25649 9.78454 8.1285 9.83319 8.0005 9.83319Z'
        fill='#25314C'
      />
    </svg>
  );
};

export default AngleDown;
